import { gql } from '@apollo/client';
import { getCartQueryString, getRichTextQueryString } from './utils';

export const getVignetteOrderingProcessCollection = gql`
query getVignetteOrderingProcessCollection($lang: String, $slug: String) {
  vignetteOrderingProcessCollection(
    locale: $lang
    limit: 1
    where: { landEnum: { landList_contains: $slug } }
  ) {
    items {
      title(locale: $lang)
      tollCategoriesHeadline(locale: $lang)
      tollCategoryReuseHeadline(locale: $lang)
      headlineProductSelection(locale: $lang)
      descriptionProductSelectionAut(locale: $lang)
      errorProductSelection(locale: $lang)
      headlineStartDate(locale: $lang)
      descriptionStartDate(locale: $lang)
      errorStartDate(locale: $lang)
      placeholderStartDate(locale: $lang)
      headlineTollSection(locale: $lang)
      errorTollSection(locale: $lang)
      errorFahrzeugauswahl(locale: $lang)
      resetTitle(locale: $lang)
      resetText(locale: $lang)
      oneCartSloveniaToast
      ${getCartQueryString()}
      validationModal {
        titleDuplicate
        textDuplicate
        changeProductLabel
        deleteProductLabel
        titleSystemDuplicate
        textSystemDuplicate
        labelContinue
        labelContinueSale
        labelCancelSale
        flexSystemDuplicateLabel
        flexCartOverlappingLabel
        multipleSystemDuplicate
		maxItemCountOrPriceText
        multipleCartDuplicateTitle
        oneCartSlovenianDateText{
          ${getRichTextQueryString()}
        }
        oneCartSlovenianDateCancel
        oneCartSlovenianDateSubmit
      }
      tollSectionInfo {
        section(locale: $lang)
        hint(locale: $lang)
        validityPeriod(locale: $lang)
        amountValidityPeriod(locale: $lang)
        chooseRoute(locale: $lang)
        chooseTrip(locale: $lang)
        errorTrips(locale: $lang)
      }
      helpDrawers: helpDrawersCollection(
        locale: $lang
        limit: 10
        ) {
        items {
          id
          helpDrawerTitle(locale: $lang)
        }
      }
      hintMessages: hintMessagesCollection(locale: $lang, limit: 10) {
        items {
          id
          tip(locale: $lang)
          linkText(locale: $lang)
          message(locale: $lang) {
            json
          }
        }
      }
      categoryClasses: categoryClassCollection(locale: $lang, limit: 3) {
        items {
          vehicleCategory(locale: $lang)
          tollCategory(locale: $lang)
          shortText(locale: $lang)
          description(locale: $lang) {
            json
          }
        }
      }
      categoryClass2BList
      oneCartTollSectionInfo(locale: $lang)
      oneCartHeadline(locale: $lang)
      oneCartCountryError(locale: $lang)
      oneCartOverviewPrices(locale: $lang)
      oneCartCountries: oneCartCountriesCollection (locale: $lang, limit: 3){
        items {
          id {
            landList
          }
          country(locale: $lang)
          description(locale: $lang){
            ${getRichTextQueryString()}
          }
        }
      }
    }
  }
}
`;
